// extracted by mini-css-extract-plugin
export default {"modal":"CruiseDetailModal_modal__DZ1+2","disclosureButton":"CruiseDetailModal_disclosureButton__Xl49U"};